import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';

import { v4 as uuid } from 'uuid';

import { icons } from '@finnairoyj/fcom-ui-styles';

@Component({
  selector: 'fin-expander-card',
  templateUrl: 'expander-card.component.html',
  styleUrls: ['expander-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpanderCardComponent implements OnInit {
  @Input() iconName = 'single-pax';
  @Input() iconCategory: keyof icons = 'svg-library';
  @Input() iconClasses: string;
  @Input() title: string;
  @Input() capitalizeTitle = true;
  @Input() subTitle: string | number;
  @Input() subTitleIcon: string;
  @Input() showSubTitleOnMobile = false;
  @Input() description: string;
  @Input() descriptionClasses: string;
  @Input() expandOpen: boolean;
  @Input() descriptionContent: TemplateRef<ElementRef>;

  expandContainerId: string;

  @Output()
  expandChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.expandContainerId = uuid();
  }

  toggleOpen(): void {
    this.expandChange.emit(this.expandOpen);
  }
}
